import { css } from '@emotion/css';

import { Colors, FontWeight } from 'apps/shared/scripts/styles/constants';

export const logoClassName = css({
  color: Colors.Primary,
});

export const textClassName = css({
  color: 'inherit',
  fontFamily: `"Nunito", sans-serif`,
  fontSize: 24,
  fontWeight: FontWeight.BOLD,
});

export const lightClassName = css({
  color: Colors.White,
});
